<template>
  <div class="raw-panel">
    <div class="d-flex align-center mb-2">
      <span class="mr-2 font-weight-medium">{{ titleText }}</span>
      <v-spacer></v-spacer>
      <v-btn small text class="mr-2" @click="copyJson" :disabled="!value">
        <v-icon left small>mdi-content-copy</v-icon>{{ tCopy }}
      </v-btn>
      <v-btn small text @click="downloadJson" :disabled="!value">
        <v-icon left small>mdi-download</v-icon>{{ tDownload }}
      </v-btn>
    </div>

    <pre class="code-block">{{ pretty }}</pre>
  </div>
</template>

<script>
export default {
  name: 'RawJsonPanel',
  props: {
    value: { type: [Object, Array, String, Number, Boolean, null], default: null },
    title: { type: String, default: null }
  },
  computed: {
    pretty() {
      try { return JSON.stringify(this.value ?? {}, null, 2); }
      catch { return '{}'; }
    },
    tCopy() { return this.$t('copy') || 'Copier'; },
    tDownload() { return this.$t('download') || 'Télécharger'; },
    titleText() { return this.title || (this.$t('job-manager.raw-json')); }
  },
  methods: {
    copyJson() {
      if (!this.value) return;
      const text = this.pretty;
      try { navigator.clipboard.writeText(text); } catch {
        const ta = document.createElement('textarea');
        ta.value = text; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch {
          // fallback for older browsers
          const range = document.createRange();
          range.selectNode(ta);
          window.getSelection().addRange(range);
          document.execCommand('copy');
        }
        document.body.removeChild(ta);
      }
    },
    downloadJson() {
      if (!this.value) return;
      const blob = new Blob([this.pretty], { type: 'application/json;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = 'data.json';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  }
};
</script>

<style lang="scss">
.code-block {
  background: #0f0f0f;
  color: #e0e0e0;
  padding: 12px;
  border-radius: 6px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre;
  overflow: auto;
  max-height: 320px;
}
</style>
